import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { DocumentChapterGroup } from '../models/document-chapter-group.js';
import { createDocumentChapterEndpoint } from './const';

export const createDocumentChapter = (documentChapter: DocumentChapterGroup) => {
    return getHttpClient().post({ url: createDocumentChapterEndpoint, data: JSON.stringify(documentChapter) });
};
